module.exports = __webpack_public_path__ + "img/77346.ce23152b.svg";